import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const AutoLoanFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4967226' height='600' />
}

export default React.memo(AutoLoanFormBlock)
